import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material';
import { Travel } from 'src/app/models/travel';
import { travelCashUrl, travelCashApproverUrl } from 'src/app/modules/shared/common/api';
import { TravelCashService } from '../../services/travel-cash/travel-cash.service';
import { User } from 'src/app/models/user';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import { TravelCashApproverViewerComponent } from '../travel-cash-approver-viewer/travel-cash-approver-viewer.component';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TravelService } from 'src/app/modules/travel/services/travel/travel.service';

@Component({
  selector: 'app-travel-cash-approver',
  templateUrl: './travel-cash-approver.component.html',
  styleUrls: ['./travel-cash-approver.component.scss']
})
export class TravelCashApproverComponent implements OnInit {

  
  keyWords = [];
  menuList = [
    {
      label:"Date Submitted",
      type: 'date',
      name:"date_submitted",
      value: [],
    },
    {
      label:"Purpose",
      type:"input",
      name:"purpose",
    },
    {
      label:"Location",
      type:"input",
      name:"location",
    },
    {
      label:"Status",
      type:"select",
      name:"status",
      value: ["For 1st Approval","For 2nd Approval","Approved","Rejected"]
    }
  ];

  pipe = new DatePipe('en-US');
  

  isNoResult: boolean = false;
  loading:boolean = false;
  isKeyWord:boolean = false;
  isRole:boolean = false;
  keyTable = '';

  totalRec : number;
  page: number = 1;
  perPage: number;
  _user = new User('');

  travel: any;
  dialogConfig:any;
  departmentList:any;
  formGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public travelCashService: TravelCashService,
    public travelService: TravelService,
    public functionService: FunctionsService,
    private route: ActivatedRoute
  ) { 
    this.isRole = this._user.getRole();
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      travel_authorization_no:['',null],
      cash_advance_no:['',null],
      complete_name: ['',null],
      date_filed: ['',null],
      date_submitted: ['',null],
      purpose:['',null],
      location: ['',null],
      status: ['',null],
      department_filter: ['',null]
    });

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';
    if (this.isRole) {
      this.travelService.getDepartment().subscribe(res=>{
        this.departmentList = res;
        this.menuList.unshift({
          label:"Department",
          type:"select",
          name:"department_filter",
          value: this.departmentList,
        });
      });

      this.menuList.unshift({
        label:"Requestor",
        type:"input",
        name:"complete_name"
      });
    }
    
    //check status param router if set
    this.route.queryParams.subscribe( params =>{
      if (params) {
        this.formGroup.controls['status'].setValue(params.status);
        this.formGroup.controls['complete_name'].setValue(params.name);
        this.formGroup.controls['department_filter'].setValue(params.department);
        this.getFilter();
      } else {
        this.getList();
      }
    });

  }

  getFilter() {
    this.page = 1;
    this.isKeyWord = true;
    if (this.isKeyWord) {
      this.keyTable = 'table-chiplist';
    }
    if(this.formGroup.controls['date_submitted'].value !== '' && this.formGroup.controls['date_submitted'].value !== null){
      this.formGroup.controls['date_submitted'].setValue(this.pipe.transform(this.formGroup.controls['date_submitted'].value, 'yyyy-MM-dd'));
    }
    this.getList();
    this.keyWords = this.functionService.filter(this.formGroup,this.keyWords);
  }

  getList() {
    let param = [];
    let queryString = '';

    if (this.page) {
      param.push('page='+this.page);
    }  

    if(this.formGroup.controls['cash_advance_no'].value !== null){
      param.push('cash_advance_no='+encodeURIComponent(this.formGroup.controls['cash_advance_no'].value));
    }

    if(this.formGroup.controls['complete_name'].value !== null){
      param.push('complete_name='+this.formGroup.controls['complete_name'].value);
    }
    
    if(this.formGroup.controls['date_submitted'].value !== null){
      param.push('date_submitted='+this.formGroup.controls['date_submitted'].value);
    }

    if(this.formGroup.controls['status'].value !== null){
      param.push('status='+this.formGroup.controls['status'].value);
    }

    if(this.formGroup.controls['purpose'].value !== null){
      param.push('purpose='+this.formGroup.controls['purpose'].value);
    }

    if(this.formGroup.controls['department_filter'].value !== null){
      param.push('department_filter='+this.formGroup.controls['department_filter'].value);
    }

    if(this.formGroup.controls['location'].value !== null){
      param.push('location='+this.formGroup.controls['location'].value);
    }
  
    if (param.length) {
      queryString = '?' + param.join('&');
    }

    this.loading = true;
    this.isNoResult = false;
    this.travelCashService.url = travelCashApproverUrl+''+ queryString;
    this.travelCashService.getFilter().subscribe(res=>{
      this.travel = new Travel(res.data);
      this.totalRec = res.total;
      this.perPage = res.per_page;
      this.loading = false;
      if (res.total == 0) {
        this.isNoResult = true;
      }
    });
  }

  onClearForm() {
    this.formGroup.reset();
    this.keyWords = [];
    this.getList();
    this.isKeyWord  = false;
    this.keyTable = '';
  }

  openDetail(res) {
    this.dialogConfig.data = {res};
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.width = '100vw';
    let dialogRef = this.dialog.open(TravelCashApproverViewerComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getList();
      }
    });
  }

  pageChange(newPage: number) {
    this.page = newPage;
    this.getList();
		return false;
  }
  
  removeKeywords(key){
    this.formGroup.controls[key].setValue('');
    this.functionService.removeFilter(this.keyWords,key);
    this.getList();
    this.keyTable = '';
  }
}
